import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import IeSignUpOptions from "../user/IeSignUpOptions";
import { breakpoints } from "../../utils/styles";
import BackButton from "../common/BackButton";
import { getCinemasById, getIeSignUpOptions } from "../../reducers";
import { fetchIeSignUpOptions } from "../../actions/creators/ie";
import BodyBlocker from "../BodyBlocker";
import CinemaSelector from "../CinemaSelector";
import FieldRow from "../FieldRow";
import { LoyaltyLevelType } from "../../types/entities";

const Container = styled.div<{ visible?: boolean }>`
  background: var(--page-bg);
  bottom: ${(props) => (props.visible ? 0 : "-100%")};
  height: 98%;
  position: fixed;
  right: 0;
  width: 100%;
  overflow-y: auto;
  transition: bottom 0.5s ease-in-out, right 0.5s ease-in-out;
  z-index: 1050;

  @media screen and (min-width: ${breakpoints.tablet}px) {
    height: 100%;
    right: ${(props) => (props.visible ? 0 : "-66.67vw")};
    top: 0;
    width: 66.66vw;
  }
`;

const CinemaSelectBlock = styled.div`
  cursor: pointer;
  height: auto;
  margin-bottom: 2.5rem;
`;

const Head = styled.div`
  text-align: center;

  @media screen and (min-width: ${breakpoints.tablet}px) {
    text-align: left;
  }
`;

interface Props {
  visible: boolean;
  cinemas: { [key: number]: any };
  levelOptions: LoyaltyLevelType[];
  onIEOptionSelect: (option: LoyaltyLevelType | null) => void;
  onCinemaChange: (cinemaId: number) => void;
  fetchIeSignUpOptions: (params: { cinemaId: number }) => void;
  close: () => void;
}

function SignUpManualIEOptions(props: Props) {
  const [selectedCinemaId, setSelectedCinemaId] = useState(0);
  const [isCinemaSelectorOpen, setCinemaSelectorOpen] = useState(false);
  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(!isCinemaSelectorOpen);
  }, [isCinemaSelectorOpen]);

  useEffect(() => {
    setCinemaSelectorOpen(false);

    if (selectedCinemaId) {
      props.onIEOptionSelect(null);
      props.onCinemaChange(selectedCinemaId);
      props.fetchIeSignUpOptions({ cinemaId: selectedCinemaId });
    }
  }, [selectedCinemaId]);

  return <>
    {props.visible && <BodyBlocker />}
    <Container className="px-5 py-4" visible={props.visible && isVisible}>
      <div className="mb-5">
        <BackButton
          onBackClick={props.close}
          label="Selecciona tu beneficio de bienvenida de Cinemex Loop"
        />
      </div>

      <Head>
        <p>
          Por favor <strong>selecciona tu cine preferido</strong> para ver las
          opciones:
        </p>

        <div className="col-md-6 pl-0">
          <CinemaSelectBlock className="form-control" onClick={() => setCinemaSelectorOpen(true)}>
            {selectedCinemaId && (selectedCinemaId in props.cinemas) ? props.cinemas[selectedCinemaId].name : 'Selecciona tu cine'}
          </CinemaSelectBlock>
        </div>
        <p className="mb-4">
          Recuerda que los boletos incluidos en el beneficio serán{" "}
          <strong>únicamente válidos en el cine seleccionado.</strong>
        </p>
      </Head>

      <IeSignUpOptions
        levels={props.levelOptions}
        onLevelSelect={props.onIEOptionSelect}
        altStyles
      />
      
      {isCinemaSelectorOpen && (
        <>
          <div style={{position: 'fixed', zIndex: 1050}}>
            <CinemaSelector
              cinemaId={selectedCinemaId}
              onClose={() => setCinemaSelectorOpen(false)}
              onCinemaSelect={(areaId, cinemaId) => setSelectedCinemaId(cinemaId)}
              open={true}
              fullWidth={true}
            />
          </div>
        </>
      )}
    </Container>
  </>;
}

const mapStateToProps = state => ({
  cinemas: getCinemasById(state),
  levelOptions: getIeSignUpOptions(state),
});

const mapDispatchToProps = {
  fetchIeSignUpOptions,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpManualIEOptions));
